module.exports = "<div class=\"text-center ui-grid-cell-contents\" ng-click=\"grid.appScope.Ctrl.showErrorsDetails(row, $index, $event)\">\n\t<p class=\"text-danger\">\n\t\t<a href=\"\">\n\t\t\t<i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i> Ver Errores\n\t\t</a>\n\t</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/u-load-file/templates/cell-template-show-errors.html
// module id = 305
// module chunks = 0